import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { publicApi, adminApi } from '../../api/client';
import { Ship, Package, Inbox, BookOpen, Loader2, ArrowRight } from 'lucide-react';

const StatCard = ({ label, value, icon: Icon, to, color = '#304b71' }) => (
  <Link to={to} className="bg-white rounded-2xl p-6 border border-slate-100 hover:shadow-lg transition-all block">
    <div className="flex items-center justify-between">
      <div className="w-12 h-12 rounded-full flex items-center justify-center text-white" style={{ backgroundColor: color }}><Icon size={20} /></div>
      <ArrowRight className="text-slate-400" size={16} />
    </div>
    <div className="font-serif text-3xl text-[#304b71] mt-4">{value}</div>
    <div className="text-slate-500 text-sm mt-1">{label}</div>
  </Link>
);

const AdminHome = () => {
  const [stats, setStats] = useState({ cruises: '—', packages: '—', blog: '—', leads: '—' });
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [c, p, b, l] = await Promise.all([publicApi.getCruises(), publicApi.getPackages(), adminApi.listBlog(), adminApi.listLeads()]);
        setStats({ cruises: c.length, packages: p.length, blog: b.length, leads: l.length });
        setRecent(l.slice(0, 5));
      } catch { /* noop */ }
      setLoading(false);
    };
    load();
  }, []);

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-serif text-3xl text-[#304b71]">Dashboard</h1>
        <p className="text-slate-500 mt-1">Welcome back to the Get Nile Cruise admin panel.</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        <StatCard label="Total Cruises" value={stats.cruises} icon={Ship} to="/admin/cruises" color="#304b71" />
        <StatCard label="Tour Packages" value={stats.packages} icon={Package} to="/admin/packages" color="#6a8aa4" />
        <StatCard label="Blog Posts" value={stats.blog} icon={BookOpen} to="/admin/blog" color="#a6b2b5" />
        <StatCard label="Total Leads" value={stats.leads} icon={Inbox} to="/admin/leads" color="#304b71" />
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-serif text-xl text-[#304b71]">Recent Inquiries</h2>
          <Link to="/admin/leads" className="text-sm text-[#304b71] hover:text-[#6a8aa4]">View all →</Link>
        </div>
        {loading ? <div className="py-10 text-center"><Loader2 className="animate-spin inline text-[#304b71]" /></div> :
          recent.length === 0 ? <div className="py-10 text-center text-slate-400 text-sm">No inquiries yet.</div> : (
            <table className="w-full text-sm">
              <thead className="text-xs uppercase text-slate-500 border-b border-slate-100">
                <tr><th className="text-left py-3">Name</th><th className="text-left">Email</th><th className="text-left">Subject</th><th className="text-left">Status</th><th className="text-left">Received</th></tr>
              </thead>
              <tbody>
                {recent.map((l) => (
                  <tr key={l.id} className="border-b border-slate-50">
                    <td className="py-3 text-slate-700">{l.name}</td>
                    <td className="text-slate-600">{l.email}</td>
                    <td className="text-slate-600">{l.subject}</td>
                    <td><span className="text-xs px-2 py-0.5 rounded-full bg-[#f6f8fa] text-[#304b71] uppercase tracking-wider">{l.status}</span></td>
                    <td className="text-slate-500">{new Date(l.created_at).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        }
      </div>
    </div>
  );
};

export default AdminHome;
